module.exports = "/lucky-balls/img/infobox/info_Box_028.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_028.png
// module id = 1093
// module chunks = 0